import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session on mount
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const loginWithGoogle = async (googleUser) => {
    // Extract user info from Google response
    const userData = {
      id: googleUser.sub || `user_${Date.now()}`,
      email: googleUser.email,
      name: googleUser.name,
      picture: googleUser.picture,
      createdAt: new Date().toISOString()
    };
    
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', googleUser.credential || 'google-token');
    setUser(userData);
    return userData;
  };

  const logout = () => {
    console.log('Logout function called');
    
    // Clear all localStorage data
    localStorage.clear();
    
    // Clear session storage
    sessionStorage.clear();
    
    // Reset user state
    setUser(null);
    
    // Redirect to login
    setTimeout(() => {
      window.location.href = '/login';
    }, 100);
  };

  const value = {
    user,
    loading,
    loginWithGoogle,
    logout,
    isAuthenticated: !!user
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
